import { useChainId, useSupportedChains } from '@thirdweb-dev/react';

export function useNetworkMismatch(): boolean {
  const chains = useSupportedChains();
  const chainId = useChainId();

  return !chains.some(chain => chain.chainId === chainId);
}
